import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { AgreementContactDto } from '../../contacts/dtos/agreement-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { RentalAgreementRecordCategoryEnum } from '../enums/rental-agreement-record-category.enum';
import { RentalAgreementTypeEnum } from '../enums/rental-agreement-type.enum';
import { RentalPartySourceTypeEnum } from '../enums/rental-party-source-type.enum';

/**
 * Names the agreement to create, including whether the booker is a customer
 * or a renter account.
 */
export class CreateRentalAgreementDto {
  color?: string | null;
  notes?: string | null;
  recordCategory!: RentalAgreementRecordCategoryEnum;
  hasFullInsurance?: boolean | null;
  agreementContact?: AgreementContactDto | null;
  type!: RentalAgreementTypeEnum;
  @TransformDate()
  startsAt!: Date;
  @TransformDate()
  endsAt!: Date;
  @TransformInt()
  vehicleId?: number | null;
  @TransformInt()
  vehicleCategoryId?: number | null;
  @TransformInt()
  pickupLocationId?: number | null;
  @TransformInt()
  dropOffLocationId?: number | null;
  /** Customer or renter account. The matching id is required and the other is rejected. */
  partyType!: RentalPartySourceTypeEnum;
  /** Set when `partyType` is customer. */
  @TransformInt()
  customerId?: number | null;
  /** Set when `partyType` is account. */
  accountUuid?: string | null;
  @TransformInt()
  agentId?: number | null;
  /** Extra drivers copied from customers. Omit on update to keep them. */
  @TransformInt()
  driverCustomerIds?: number[] | null;
  /** Extra drivers copied from renter accounts. Omit on update to keep them. */
  driverAccountUuids?: string[] | null;
  pricingItems?: PricingItemDto[] | null;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
